import internationalCallingCodes from './internationalCallingCodes';

const getCountryCallingCode = (countryCode: string) =>
  internationalCallingCodes.hasOwnProperty(countryCode)
    ? internationalCallingCodes[countryCode].code.toString()
    : '';

export default getCountryCallingCode;
